{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Esat pārsniedzis sarunu limitu. Hacker plāns atļauj tikai 500 sarunas.",
      "INBOXES": "Esat pārsniedzis iesūtņu limitu. Hacker plāns atbalsta tikai vietnes tiešsaistes tērzēšanu. Papildu iesūtnēm, piemēram, e-pastam, WhatsApp u.c., nepieciešams maksas plāns.",
      "AGENTS": "Esat pārsniedzis aģentu limitu. Hacker plāns atļauj tikai 2 aģentus.",
      "NON_ADMIN": "Lūdzu, sazinieties ar administratoru, lai uzlabotu plānu un turpinātu izmantot visas funkcijas."
    },
    "TITLE": "Konta iestatījumi",
    "SUBMIT": "Atjaunināt iestatījumus",
    "BACK": "Atpakaļ",
    "DISMISS": "Atcelt",
    "UPDATE": {
      "ERROR": "Nevarēja atjaunināt iestatījumus, mēģiniet vēlreiz!",
      "SUCCESS": "Konta iestatījumi ir veiksmīgi atjaunināti"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Dzēst Jūsu Kontu",
      "NOTE": "Kad izdzēsīsiet savu kontu, visi Jūsu dati tiks dzēsti.",
      "BUTTON_TEXT": "Dzēst Jūsu Kontu",
      "CONFIRM": {
        "TITLE": "Dzēst Kontu",
        "MESSAGE": "Konta dzēšana ir neatgriezeniska. Ievadiet zemāk sava konta nosaukumu, lai apstiprinātu, ka vēlaties to neatgriezeniski dzēst.",
        "BUTTON_TEXT": "Dzēst",
        "DISMISS": "Atcelt",
        "PLACE_HOLDER": "Lūdzu, ievadiet {accountName}, lai apstiprinātu"
      },
      "SUCCESS": "Konts atzīmēts dzēšanai",
      "FAILURE": "Neizdevās dzēst kontu, mēģiniet vēlreiz!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Šis konts ir ieplānots dzēšanai {deletionDate}. To pieprasīja administrators. Jūs varat atcelt dzēšanu pirms šī datuma.",
        "MESSAGE_INACTIVITY": "Šis konts ir ieplānots dzēšanai {deletionDate} konta neaktivitātes dēļ. Jūs varat atcelt dzēšanu pirms šī datuma.",
        "CLEAR_BUTTON": "Atcelt Ieplānoto Dzēšanu"
      }
    },
    "FORM": {
      "ERROR": "Lūdzu, izlabojiet veidlapas kļūdas",
      "GENERAL_SECTION": {
        "TITLE": "Vispārīgie iestatījumi",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Konta ID",
        "NOTE": "Šis ID ir nepieciešams, ja veidojat uz API balstītu integrāciju"
      },
      "NAME": {
        "LABEL": "Konta nosaukums",
        "PLACEHOLDER": "Jūsu konta nosaukums",
        "ERROR": "Lūdzu, ievadiet derīgu konta nosaukumu"
      },
      "LANGUAGE": {
        "LABEL": "Vietnes valoda",
        "PLACEHOLDER": "Jūsu konta nosaukums",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Ienākošā e-pasta domēns",
        "PLACEHOLDER": "Domēns, kurā saņemsiet e-pastus",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Atbalsta e-pasts",
        "PLACEHOLDER": "Jūsu uzņēmuma atbalsta e-pasts",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Dienu skaits pēc kā biļetei ir automātiski jāatrisinās, ja nenotiek nekādas darbības",
        "NOTE": "Neaktivitātes stundu skaits, pēc kura jebkura atvērta saruna tiks automātiski atrisināta.",
        "PLACEHOLDER": "30",
        "ERROR": "Lūdzu, ievadiet derīgu automātiskās atrisināšanas ilgumu (vismaz 1 diena un ne vairāk kā 999 dienas)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Dienu skaits, pēc kura tukša saruna tiek automātiski atrisināta, ja nav nekādas aktivitātes",
        "PLACEHOLDER": "nekad",
        "ERROR": "Lūdzu, ievadiet derīgu tukšas sarunas automātiskās atrisināšanas ilgumu (vismaz 1 diena un ne vairāk kā 999 dienas)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Jūsu kontam ir iespējota sarunu nepārtrauktība ar e-pastiem.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Tagad Jūs varat saņemt e-pasta ziņojumus savā pielāgotajā domēnā."
      },
      "PHONE": {
        "TITLE": "PBX Iestatījumi",
        "NOTE": "Konfigurējiet savienojumu ar Jūsu PBX tālruņa zvaniem",
        "SIP_HOST": {
          "LABEL": "SIP domēns"
        },
        "DIALING_MODE": {
          "LABEL": "Zvanīšanas režīms",
          "MODES": {
            "direct": "Tiešais - zvans tiek uzreiz sastādīts, noklikšķinot uz tālruņa saites",
            "indirect": "Netiešais - tālruņa numurs tiek sagatavots tālruņa logrīka ievades laukā"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Piekļuve zvanu ierakstiem",
          "MODES": {
            "admin_only": "Tikai administratori",
            "admin_and_assigned_agent": "Administratori un piešķirtais aģents",
            "inbox_members": "Visi aģenti ar piekļuvi iesūtnei"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-pasta Iestatījumi",
        "NOTE": "Maina e-pasta iesūtņu darbību"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Sarunas laika zīmoga attēlošanas režīms",
        "MODES": {
          "both": "Izveidošana un pēdējā aktivitāte",
          "last_activity_only": "Tikai pēdējā aktivitāte",
          "last_customer_message": "Pēdējais klienta ziņojums"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Bloķēt domēnus ar zemu reputāciju"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Iekļaut oriģinālo ziņojumu e-pasta atbildē"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automātiski atrisināt jaunu sarunu"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automātiski pārvietot jaunu e-pasta sarunu uz tā robota iesūtni, kurš apstrādāja kontakta pasūtījumus"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Paplašinātas etiķetes - atļaut garākus etiķešu nosaukumus ar lielāku uznirstošo saskarni"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - automātiski piešķirt sarunu aģentam, kurš sniedza pēdējo atbildi"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Push paziņojumu režīms",
        "MODES": {
          "all_inboxes": "Visas iesūtnes - sūtīt paziņojumus par visiem kanālu tipiem",
          "chat_only": "Tikai tērzēšana - sūtīt paziņojumus tikai par kanāliem, kas nav e-pasts"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Atļaut ieslēgt/izslēgt parakstu nosūtītajos ziņojumos"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Rādīt aģenta tērzēšanas statusu Wallboard panelī"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Rādīt pilnus pielikumu nosaukumus bez saīsināšanas"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Pieteikšanās ar paroli",
        "MODES": {
          "allowed_for_all": "Atļauts visiem lietotājiem",
          "allowed_for_agents_only": "Atļauts tikai aģentiem (administratoriem jāizmanto OAuth)",
          "password_login_disabled": "Atspējots - tikai OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Pieejama jauna versija. Pārlādējiet, lai iegūtu jaunākos atjauninājumus.",
    "RELOAD_NOW": "Atjaunināt tagad",
    "LEARN_MORE": "Uzzināt vairāk",
    "PAYMENT_PENDING": "Jūsu maksājums tiek gaidīts. Lūdzu, atjauniniet savu maksājumu informāciju, lai turpinātu lietot šo programmatūru",
    "LIMITS_UPGRADE": "Jūsu konts ir pārsniedzis lietošanas ierobežojumus. Lūdzu, uzlabojiet savu abonementu, lai turpinātu izmantot šo programmatūru",
    "OPEN_BILLING": "Atvērt norēķinus"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Nospiediet enter, lai izvēlētos",
      "ENTER_TO_REMOVE": "Nospiediet enter, lai noņemtu",
      "NO_OPTIONS": "Saraksts ir tukšs",
      "NO_RESULT": "Rezultāti nav atrasti",
      "SELECT_ONE": "Izvēlieties vienu",
      "SELECT": "Izvēlieties"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Paziņojumi",
    "MARK_ALL_DONE": "Atzīmēt visu kā pabeigtu",
    "DELETE_TITLE": "dzēsts",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Nelasīti paziņojumi",
      "ALL_NOTIFICATIONS": "Skatīt visus paziņojumus",
      "LOADING_UNREAD_MESSAGE": "Notiek nelasītu paziņojumu ielāde...",
      "EMPTY_MESSAGE": "Jums nav nelasītu paziņojumu"
    },
    "LIST": {
      "LOADING_MESSAGE": "Notiek paziņojumu ielāde...",
      "404": "Nav paziņojumu",
      "TABLE_HEADER": [
        "Nosaukums",
        "Telefona numurs",
        "Sarunas",
        "Pēdējā Sazināšanās"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Jauna saruna",
      "conversation_assignment": "Saruna Piešķirta",
      "assigned_conversation_new_message": "Jauns ziņojums",
      "participating_conversation_new_message": "Jauns ziņojums",
      "conversation_mention": "Pieminēt",
      "sla_missed_first_response": "SLA Nokavēts",
      "sla_missed_next_response": "SLA Nokavēts",
      "sla_missed_resolution": "SLA Nokavēts"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Bezsaistē",
      "RECONNECTING": "Notiek savienojuma atjaunošana...",
      "RECONNECT_SUCCESS": "Atkārtoti izveidots savienojums"
    },
    "BUTTON": {
      "REFRESH": "Atjaunot"
    },
    "CONNECTION_LOST": {
      "TITLE": "Savienojums zaudēts",
      "DESCRIPTION": "Neizdevās sasniegt serveri. Pārbaudiet savienojumu un mēģiniet vēlreiz.",
      "RETRY": "Mēģināt vēlreiz"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Meklēt vai pāriet uz",
    "SECTIONS": {
      "GENERAL": "Vispārēji",
      "REPORTS": "Pārskati",
      "CONVERSATION": "Saruna",
      "BULK_ACTIONS": "Lielapjoma Darbības",
      "CHANGE_ASSIGNEE": "Mainīt Pilnvaroto",
      "CHANGE_PRIORITY": "Mainīt prioritāti",
      "CHANGE_TEAM": "Mainīt Komandu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "EXECUTE_MACRO": "Izpildīt Makro",
      "ADD_LABEL": "Pievienot sarunai etiķeti",
      "REMOVE_LABEL": "Noņemt etiķeti no sarunas",
      "SETTINGS": "Iestatījumi",
      "AI_ASSIST": "AI Palīgs",
      "APPEARANCE": "Izskats",
      "SNOOZE_NOTIFICATION": "Atlikt Paziņojumu"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Doties uz Sarunu Informācijas Paneli",
      "GO_TO_CONTACTS_DASHBOARD": "Doties uz Kontaktpersonu Informācijas Paneli",
      "GO_TO_REPORTS_OVERVIEW": "Doties uz Pārskatu Kopsavilkumu",
      "GO_TO_CONVERSATION_REPORTS": "Doties uz Sarunu Pārskatiem",
      "GO_TO_AGENT_REPORTS": "Doties uz Aģentu Pārskatiem",
      "GO_TO_LABEL_REPORTS": "Doties uz Etiķešu Pārskatiem",
      "GO_TO_INBOX_REPORTS": "Doties uz Iesūtnes Pārskatiem",
      "GO_TO_TEAM_REPORTS": "Doties uz Komandas Pārskatiem",
      "GO_TO_SETTINGS_AGENTS": "Doties uz Aģentu Iestatījumiem",
      "GO_TO_SETTINGS_TEAMS": "Doties uz Komandas Iestatījumiem",
      "GO_TO_SETTINGS_INBOXES": "Doties uz Iesūtnes Iestatījumiem",
      "GO_TO_SETTINGS_LABELS": "Doties uz Etiķešu Iestatījumiem",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Doties uz Sagatavoto Atbilžu Iestatījumiem",
      "GO_TO_SETTINGS_APPLICATIONS": "Doties uz Lietojumprogrammas Iestatījumiem",
      "GO_TO_SETTINGS_ACCOUNT": "Doties uz Konta Iestatījumiem",
      "GO_TO_SETTINGS_PROFILE": "Doties uz Profila Iestatījumiem",
      "GO_TO_NOTIFICATIONS": "Doties uz Paziņojumiem",
      "ADD_LABELS_TO_CONVERSATION": "Pievienot sarunai etiķeti",
      "ASSIGN_AN_AGENT": "Piešķirt aģentu",
      "AI_ASSIST": "AI Palīgs",
      "ASSIGN_PRIORITY": "Piešķirt prioritāti",
      "ASSIGN_A_TEAM": "Piešķirt komandu",
      "EXECUTE_A_MACRO": "Izpildīt makro",
      "MUTE_CONVERSATION": "Izslēgt sarunu",
      "UNMUTE_CONVERSATION": "Ieslēgt sarunu",
      "REMOVE_LABEL_FROM_CONVERSATION": "Noņemt etiķeti no sarunas",
      "REOPEN_CONVERSATION": "Atkārtoti atvērt sarunu",
      "RESOLVE_CONVERSATION": "Atrisināt sarunu",
      "SEND_TRANSCRIPT": "Nosūtīt uz e-pastu transkriptu",
      "SNOOZE_CONVERSATION": "Atlikt Sarunu",
      "UNTIL_NEXT_REPLY": "Līdz nākamajai atbildei",
      "UNTIL_NEXT_WEEK": "Līdz nākamajai nedēļai",
      "UNTIL_TOMORROW": "Līdz rītdienai",
      "UNTIL_NEXT_MONTH": "Līdz nākamajam mēnesim",
      "AN_HOUR_FROM_NOW": "Līdz stundai, no šī brīža",
      "UNTIL_CUSTOM_TIME": "Pielāgot...",
      "CHANGE_APPEARANCE": "Mainīt Izskatu",
      "LIGHT_MODE": "Gaišs",
      "DARK_MODE": "Tumšs",
      "SYSTEM_MODE": "Sistēma",
      "SNOOZE_NOTIFICATION": "Atlikt Paziņojumu"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Notiek informācijas paneļa lietotnes ielāde..."
  },
  "COMMON": {
    "OR": "Vai",
    "CLICK_HERE": "noklikšķiniet šeit"
  }
}
